import React, { useState } from 'react';
import SimulationModal from './SimulationModal';

const UserProfileCard = ({ userData, updateTradeMode }) => {
  const [showSimConfirm, setShowSimConfirm] = useState(false);
  const [simInput, setSimInput] = useState('');
  const [pendingDecision, setPendingDecision] = useState(null);

  if (!userData) return null;

  const handleTradeDecision = (outcome) => {
    setPendingDecision(outcome);
    setSimInput('');
    setShowSimConfirm(true);
  };

  const confirmDecision = async () => {
    setShowSimConfirm(false);
    if (updateTradeMode) {
      await updateTradeMode(pendingDecision, simInput);
    }
  };

  return (
    <div className='col-12'>
      <div className='card shadow-sm border-0'>
        <div
          className='card-header bg-gradient text-white'
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          }}
        >
          <h5 className='mb-0'>
            <i className='bi bi-person-circle me-2'></i>User Information
          </h5>
        </div>
        <div className='card-body p-4'>
          {/* User Info */}
          <div className='row g-3 mb-4'>
            <div className='col-md-6'>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>User UID</small>
                <span className='badge bg-secondary px-3 py-2 fs-6'>
                  {userData.uid}
                </span>
              </div>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>Email</small>
                <div className='fw-semibold'>{userData.email}</div>
              </div>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>Full Name</small>
                <div className='fw-semibold'>{userData.fullName || 'N/A'}</div>
              </div>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>Phone</small>
                <div className='fw-semibold'>{userData.phone || 'N/A'}</div>
              </div>
            </div>

            <div className='col-md-6'>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>Status</small>
                <span
                  className={`badge ${
                    userData.status === 'ACTIVE' ? 'bg-success' : 'bg-danger'
                  } px-3 py-2`}
                >
                  {userData.status}
                </span>
              </div>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>KYC Status</small>
                <span
                  className={`badge ${
                    userData.kycStatus === 'APPROVED'
                      ? 'bg-success'
                      : userData.kycStatus === 'PENDING'
                      ? 'bg-warning text-dark'
                      : 'bg-danger'
                  } px-3 py-2`}
                >
                  {userData.kycStatus}
                </span>
              </div>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>Country</small>
                <div className='fw-semibold text-capitalize'>
                  {userData.country || 'N/A'}
                </div>
              </div>
              <div className='mb-3'>
                <small className='text-muted d-block mb-1'>
                  Current Trade Outcome
                </small>
                <span
                  className={`badge ${
                    userData.forcedTradeOutcome === 'FORCE_WIN'
                      ? 'bg-success'
                      : userData.forcedTradeOutcome === 'FORCE_LOSE'
                      ? 'bg-danger'
                      : 'bg-secondary'
                  } px-3 py-2`}
                >
                  {userData.forcedTradeOutcome || 'NONE'}
                </span>
              </div>
            </div>
          </div>

          {/* Admin Trade Decision Section */}
          <div className='card border-0 shadow-sm bg-light'>
            <div className='card-body'>
              <h6 className='text-dark mb-3 fw-bold'>
                <i className='bi bi-lightning-charge-fill me-2'></i>Admin Trade
                Decision
              </h6>
              <div className='d-flex flex-wrap gap-3'>
                <button
                  className='btn btn-success px-4 py-2'
                  onClick={() => handleTradeDecision('FORCE_WIN')}
                >
                  <i className='bi bi-check-circle-fill me-2'></i>
                  Force Win
                </button>
                <button
                  className='btn btn-danger px-4 py-2'
                  onClick={() => handleTradeDecision('FORCE_LOSE')}
                >
                  <i className='bi bi-x-circle-fill me-2'></i>
                  Force Loss
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SimulationModal
        showConfirm={showSimConfirm}
        showResult={false}
        simConfig={{}}
        simInput={simInput}
        onSimInputChange={(v) => setSimInput(v)}
        onCancelConfirm={() => setShowSimConfirm(false)}
        onConfirmOk={confirmDecision}
        onCloseResult={() => {}}
      />
    </div>
  );
};

export default UserProfileCard;
